import * as React from 'react'
import styled, { keyframes } from "styled-components";

const Container = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`

const animation = keyframes`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`

const LoaderIcon = styled.div`
  border-radius: 50%;
  display: block;
  width: 28px;
  height: 28px;
  animation: 0.6s linear 0s infinite normal none running ${animation};
  transition: opacity 0.1s ease-out;
  opacity: 1;
  border-style: solid;
  border-color: rgb(115, 115, 118) rgba(115, 115, 118, 0.3) rgba(115, 115, 118, 0.3);
  border-width: 1px;
`

const Loader = () => {
  return (
    <Container>
      <LoaderIcon />
    </Container>
  )
}

export default Loader
